import React, { useState , useRef, useEffect} from 'react';
import styles from './silentStudyArea.module.css';
import Calendar from '../Calendar/Calendar.jsx';

import Grid from '@mui/material/Unstable_Grid2';
import Avatar from '@mui/material/Avatar';

import FriendsList from '../../miscellaneous/FriendsList/FriendsList.jsx';
import { Link } from "react-router-dom";

import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import Paper from '@mui/material/Paper';
import { Height } from '@mui/icons-material';

import { CgCheck } from "react-icons/cg";    // Check mark overlaying the profile pic. 
// import { IoIosCheckmark } from "react-icons/io";
// import { BsCheck } from "react-icons/bs";

import { IoMdClose } from "react-icons/io";

import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';
import SessionClickedOverlayForSilentStudy from './SessionClickedOverlayForSilentStudy/SessionClickedOverlayForSilentStudy.jsx';
//For now we are using the same booked overlay for both discuss and learn and silent study. So we are using the same component. 
import SessionBookedOverlayForDiscussAndLearn from '../DiscussAndLearnArea/SessionBookedOverlayForDiscussAndLearn/SessionBookedOverlayForDiscussAndLearn.jsx';

import { axiosInstance } from '../../../lib/axiosInstance.js';
import { Calendar as SmallCalendar } from 'react-calendar';     // Importing as small calendar to avoid conflict and confusion with the main calendar.


//---------------------------------------------------------------------------------


function SilentStudyArea() {
  const {isMobile, bookedPersonArray, setBookedPersonArray, isSilentStudyBookingDone, calendarMonthAndYear, smallCalendarSelectedDate, setSmallCalendarSelectedDate, showFriendsList, setShowFriendsList, showStrangersList, showMyProfile, clickedGridTimeInDayHourMinute, setClickedGridTimeInDayHourMinute, subject, category, datesWithDayMonthYear} = useGlobalState();




  //-----Display small calendar or not.----------------

  const [displaySmallCalendar, setDisplaySmallCalendar] = useState(false);
  function handleDisplaySmallCalendar(){
    if (displaySmallCalendar===false){
      setDisplaySmallCalendar(true);
    }else if (displaySmallCalendar===true){
      setDisplaySmallCalendar(false);
    }
  }

  //------
  // After adding the below it seems like it is taking too much time to load when you run "npm start".
  const displaySmallCalendarRef = useRef(null);
  const smallCalendarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (displaySmallCalendarRef.current && !displaySmallCalendarRef.current.contains(event.target) && smallCalendarRef.current && !smallCalendarRef.current.contains(event.target)) {
        // Clicked outside the component
        //console.log('Clicked outside!');
        setDisplaySmallCalendar(false);
      }
    }

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);


  const handleDateChange = (newDate) => {
    //setSmallCalendarSelectedDate(newDate);
    //setSmallCalendarSelectedDate(Math.floor(newDate.getTime() / 1000));   // Unix timestamp in seconds
    //setSmallCalendarSelectedDate(newDate.getTime());   // Unix timestamp in milli seconds   //Actually the newDate parameter just gives selected date so it is not the exact time in millisecond.
    //console.log("nnnnnnnnnnnnnewDate : "+newDate);
    setSmallCalendarSelectedDate(newDate);
  };










  //--------------Sessions display stuff----------------
  //console.log("cccccccclickedGridTimeInDayHourMinute : "+JSON.stringify(clickedGridTimeInDayHourMinute, null, 2));


  const [allSessions, setAllSessions]=useState([]);   
  //const [strangersSession, setStrangersSession]=useState([]); 
  const [mySessions, setMySessions] = useState([]);



  // Function to convert the time.  
  function convertTimeToIndividualUnits(array) {
    return array.map(item => {
      const date = new Date(item.time);
      return {
        day: date.getDate(),
        month: date.getMonth() + 1, // Months are zero-indexed
        year: date.getFullYear(),
        hour: date.getHours(),
        minutes: date.getMinutes(),
        ...item // Spread the original object properties
      };
    });
  }
  

  // Function to filter out future sessions and convert the time.
  function convertTimeToIndividualUnitsAndFilterFutureSessions(array) {
    const currentTime = new Date();
  
    return array
      .filter(item => new Date(item.time) >= currentTime) // Filter items with time >= current time
      .map(item => {
        const date = new Date(item.time);
        return {
          day: date.getDate(),
          month: date.getMonth() + 1, // Months are zero-indexed
          year: date.getFullYear(),
          hour: date.getHours(),
          minutes: date.getMinutes(),
          ...item // Spread the original object properties
        };
      });
  }



  //Below also have to add the list of people to be shown in the strangersList by segregating using time using "clickedGridTimeInDayHourMinute" global state and send it to StrangersList component. 
  useEffect(()=>{
    async function getSessions(){
      try {
        if (datesWithDayMonthYear && (datesWithDayMonthYear.length === 7 || datesWithDayMonthYear.length === 1 ) ) {    //Is this really needed?

          //---------------calling "api/sessions"-----------------
          //const response = await axiosInstance.get(`/sessions?startDate=2024-12-23&endDate=2024-12-29&subject=${subject}`);

          let calendarStartDate;
          let calendarEndDate;
          if (datesWithDayMonthYear.length === 7) {
            // Access the first and seventh values
            calendarStartDate = datesWithDayMonthYear[0];
            calendarEndDate = datesWithDayMonthYear[6];
          } else if (datesWithDayMonthYear.length === 1) {
            // Access the first value
            calendarStartDate = datesWithDayMonthYear[0];
            calendarEndDate = datesWithDayMonthYear[1];       //If we give 0 here backend will give bad request error.
          }
        
          //const startDate = `${calendarStartDate.year}-${calendarStartDate.month}-${calendarStartDate.dayNumber}`;
          //const endDate = `${calendarEndDate.year}-${calendarEndDate.month}-${calendarEndDate.dayNumber}`;

          const startDate = dayjs(`${calendarStartDate.year}-${calendarStartDate.month}-${calendarStartDate.dayNumber}`).format('YYYY-MM-DD');
          const endDate = dayjs(`${calendarEndDate.year}-${calendarEndDate.month}-${calendarEndDate.dayNumber}`).format('YYYY-MM-DD');

          // const startDate = `${calendarStartDate.year}-${calendarStartDate.month.padStart(2, '0')}-${calendarStartDate.dayNumber.padStart(2, '0')}`;
          // const endDate = `${calendarEndDate.year}-${calendarEndDate.month.padStart(2, '0')}-${calendarEndDate.dayNumber.padStart(2, '0')}`;

          //console.log(`1Fetching sessions from ${JSON.stringify(calendarStartDate)} to ${JSON.stringify(calendarEndDate)}`);
          //console.log(`Fetching sessions from ${startDate} to ${endDate}`);


          const response = await axiosInstance.get(`/sessions?startDate=${startDate}&endDate=${endDate}&subject=${''}&type=${(category==='discuss_and_learn')?'Discuss and learn with partner':'Silent study with partner'}`);

          //const response = await axiosInstance.get('/sessions?startDate=2024-12-23&endDate=2024-12-29');   
          //const response = await axiosInstance.get('/sessions');    //You have to give {category : , subject:  , start date of the week: } here after Sameedh has added the ability to give paramters.


          //console.log("allSessions response.data : "+JSON.stringify(response.data, null, 2));
          //console.log("allSessions number response.data : "+JSON.stringify(response.data.length));
          //Maybe we should add await below.
          const DandLConvertedArrayOfIndividualTimeUnits = convertTimeToIndividualUnitsAndFilterFutureSessions(response.data);   //converting mongodb time to day month year time.
          setAllSessions(DandLConvertedArrayOfIndividualTimeUnits);

          //DandLConvertedArrayOfIndividualTimeUnits = convertTimeArray(DandLCalenderArray);

          //console.log("7 DandLConvertedArrayOfIndividualTimeUnits : "+JSON.stringify(DandLConvertedArrayOfIndividualTimeUnits, null, 2));





          //--------Filtering sessions for sending to SessionClickedOverlayForSilentStudy component.----------------

          // Parameters for filtering
          /*
          const filterParams = {
            "year": 2024,
            "month": 10,
            "day": 3,
            "hour": 13,
            "minute": 32
          };*/

          const filterParams = clickedGridTimeInDayHourMinute;
          filterParams.subject = "";
          filterParams.type = "Silent study with partner";    //"silent_study" in front end "Silent study with partner" in backend.
          //console.log("ffffffffffilterParams : "+JSON.stringify(filterParams, null, 2));

          const sessions = DandLConvertedArrayOfIndividualTimeUnits;

          // Function to filter sessions based on parameters
          const filteredSessions = sessions.filter(session =>
            session.year === filterParams.year &&
            session.month === filterParams.month &&
            session.day === filterParams.dayNumber &&
            session.hour === filterParams.hour &&
            session.minutes === filterParams.minute       //Have not added subject and type here. Because we have already filtered the sessions based on type and subject above.
          );

          //setStrangersSession(filteredSessions);  //Getting the stranger's session if any already created for the clicked grid.
          setBookedPersonArray(filteredSessions);  //Getting the stranger's session if any already created for the clicked grid.





          //Maybe we should call the '/sessions/mine' api given below when we close strangerList. So it needs to be here I guess. Or because web socket is not yet done.
          //---------------calling "api/sessions/mine"-----------------

          const mineResponse = await axiosInstance.get('/sessions/mine'); 
          setMySessions(convertTimeToIndividualUnits(mineResponse.data));
        } else {
          //console.error("datesWithDayMonthYear array is not properly defined or has insufficient elements.");
          console.log("datesWithDayMonthYear array is not properly defined or has insufficient elements.");
          return;
        }

      } catch (error) {
        console.log("error from discussAndLearnArea : "+error);
      }
    }

    // Call getSessions immediately
    getSessions();

    // Set up interval to call getSessions every 10 seconds
    const intervalId = setInterval(getSessions, 10000);

    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  },[category, subject, showStrangersList, datesWithDayMonthYear, isSilentStudyBookingDone])   //Add calendar left arrow and right arrow click state here.

  





  //------------------return statement below. --------------------------------
  return(
    <div className={styles.main_div}>

      {/*----------------Render friends list  (note the class used for now is fl)--------------- */}

      {(showFriendsList===true)&&(<FriendsList/>)}

      

      {/*----------------Calendar top dash div--------------- */}

      <div className={styles.calendar_top_dash_div}>
        <p ref={displaySmallCalendarRef} onClick={handleDisplaySmallCalendar} className={styles.month_and_year_p_tag}>{calendarMonthAndYear}</p>
      </div>
      
      {displaySmallCalendar && (
        <div ref={smallCalendarRef} style={{position: 'absolute', top: '25%', left: '22%' ,zIndex: 5 }}>
          {/*<Calendar minDate={new Date()} onChange={handleDateChange} value={new Date(smallCalendarSelectedDate)}/>*/}
          <SmallCalendar minDate={new Date()} onChange={handleDateChange} value={smallCalendarSelectedDate}/>
        </div>
      )}


      {/*----------------Calendar--------------- */}
      {/* <Calendar calendarHeightProp={styles.calendar_height} calendarSessionArrayProp={allSessions} mySessions={mySessions} SessionClickedOverlayBox={<SessionClickedOverlayForSilentStudy bookedPersonArray={strangersSession}/>} SessionBookedOverlayBox={SessionBookedOverlayForDiscussAndLearn}/> */}
      
      {/*For now we are using the same booked overlay for both discuss and learn and silent study. So we are using the same component. */}
      <Calendar calendarHeightProp={styles.calendar_height} calendarSessionArrayProp={allSessions} mySessions={mySessions} SessionClickedOverlayBox={SessionClickedOverlayForSilentStudy} SessionBookedOverlayBox={SessionBookedOverlayForDiscussAndLearn}/>

    </div>
  )
}

export default SilentStudyArea;

